import { render } from "./indexsevenfeedback.vue?vue&type=template&id=6dac1790"
import script from "./indexsevenfeedback.vue?vue&type=script&lang=js"
export * from "./indexsevenfeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__